module.exports = __webpack_public_path__ + "static/media/SC-MINI.21ea2aa3.pdf";